<template>
  <div class="award" style="">
    <div class="award-reward">
      <div class="title">大赛奖励</div>
      <div class="award-reward-content">
        <div class="tips">
          <p>根据划分的不同组别分别排名，每月、每季度和年终都进行评选，</p>
          <p>
            对月排名前三、季度排名前五、年度排名前十的私募机构颁发证书、奖杯以及兑现相关奖励。
          </p>
        </div>
        <div class="month">
          <p class="title">月度/季度奖项设置：</p>
          <table>
            <tr class="bg-color">
              <td>策略类别</td>
              <td>奖项</td>
              <td colspan="2">排名方式</td>
            </tr>
            <tr>
              <td>权益组</td>
              <td>冠、亚、季军</td>
              <td colspan="2">当月综合总分前三/季度综合总分前五</td>
            </tr>
            <tr class="bg-color2">
              <td>相对价值&amp;混合策略组</td>
              <td>冠、亚、季军</td>
              <td colspan="2">当月综合总分前三/季度综合总分前五</td>
            </tr>
            <tr>
              <td>CTA组</td>
              <td>冠、亚、季军</td>
              <td colspan="2">当月综合总分前三/季度综合总分前五</td>
            </tr>
            <tr class="bg-color2">
              <td>期权组</td>
              <td>冠、亚、季军</td>
              <td colspan="2">当月综合总分前三/季度综合总分前五</td>
            </tr>
          </table>
        </div>
        <div class="year">
          <p class="title">年度奖项规则</p>
          <table>
            <tr class="bg-color">
              <td>策略类别</td>
              <td>奖项</td>
              <td colspan="2">排名方式</td>
            </tr>
            <tr>
              <td>权益组</td>
              <td>冠、亚、季军</td>
              <td colspan="2">全年综合总分前十</td>
            </tr>
            <tr class="bg-color2">
              <td>相对价值&amp;混合策略组</td>
              <td>冠、亚、季军</td>
              <td colspan="2">全年综合总分前十</td>
            </tr>
            <tr>
              <td>CTA组</td>
              <td>冠、亚、季军</td>
              <td colspan="2">全年综合总分前十</td>
            </tr>
            <tr class="bg-color2">
              <td>期权组</td>
              <td>冠、亚、季军</td>
              <td colspan="2">全年综合总分前十</td>
            </tr>
            <tr class="bg-color">
              <td>特色奖项</td>
              <td colspan="3">排名方式</td>
            </tr>
            <tr>
              <td>风格稳定奖</td>
              <td colspan="3">最大回撤不超过4%且收益回撤比最高</td>
            </tr>
            <tr class="bg-color2">
              <td>收益明星奖</td>
              <td colspan="3">年化收益率最高，参赛时间不得少于6个月</td>
            </tr>
            <tr>
              <td>新锐私募奖</td>
              <td colspan="3">
                首支产品成立时间在2021年1月1日后的机构中参赛期间专家评审分数*0.5+收益风险比标准分*0.5最高的机构
              </td>
            </tr>
            <tr class="bg-color2">
              <td>最具潜力奖</td>
              <td colspan="3">定量得分最高，参赛时间不得少于6个月</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="award-standard">
      <div class="title">大赛权益</div>
      <div class="award-standard-content">
        <div class="item">
          <div class="item-left">
            <img src="../assets/img/standard1.png" />
          </div>
          <div class="item-right">
            <p class="title">获奖证书和奖杯等</p>
            <!---->
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            <img src="../assets/img/standard2.png" />
          </div>
          <div class="item-right">
            <p class="title">强大的资金对接服务全面助力中小型私募发展</p>
            <div class="content">
              <p>1.累积超10亿元的种子资金跟投。</p>
              <p>2.优先进入申万宏源证券代销白名单。</p>
              <p>3.优先享受申万宏源Matrix主经纪商服务。</p>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            <img src="../assets/img/standard3.png" />
          </div>
          <div class="item-right">
            <p class="title">主办方强大的综合服务支持</p>
            <div class="content">
              <p>
                1.参赛机构同等条件下优先参与申万宏源证券举办的线上线下私募交流会、闭门资金对接会、参与申万宏源年度圆桌论坛、衍生品论坛和高端客户交流会等。
              </p>
              <p>2.优先享受参与希施玛公司举办的各类线上与线下深度专业活动。</p>
              <p>3.优先享受希施玛公司数据服务产品免费使用权。</p>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            <img src="../assets/img/standard4.png" />
          </div>
          <div class="item-right">
            <p class="title">
              全程媒体曝光，持续打造赛事热度及参赛私募品牌曝光度
            </p>
            <div class="content">
              <p>
                大型纸媒+网媒+私募排排网自媒体矩阵宣传，提升知名度；协办方私募排排网支持参赛私募上线私募排排网路演平台，直接与110万高净值客户面对面交流，并可安排获奖及优质私募机构接受媒体采访，定制公司品牌包装推广服务。
              </p>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            <img src="../assets/img/standard5.png" />
          </div>
          <div class="item-right">
            <p class="title">与业内知名人士、协办机构及商会的交流合作机会</p>
            <div class="content">
              <p>
                大赛组委会将邀请主办方及协办方嘉宾组成专家评委，为大赛进行优胜者评选及颁奖，参赛机构将有机会与业内知名人士进行交流。
              </p>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            <img src="../assets/img/standard6.png" />
          </div>
          <div class="item-right">
            <p class="title">申万宏源托管服务的费率折扣</p>
            <div class="content">
              <p>
                申万宏源证券托管中心对参赛及获奖的私募机构提供托管服务费率折扣，自获奖结果公布之日起后续发行的产品选择申万宏源证券托管运营的将适用该折扣（月/季/年度前3名：首单免费；月/季/年度前4-10名：首单6折；参赛：首单8折）。同时，托管中心将指定专人为机构管理人提供一对一VIP专享服务。
              </p>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            <img src="../assets/img/standard7.png" />
          </div>
          <div class="item-right">
            <p class="title">额外大赛奖品</p>
            <div class="content">
              <p>
                参赛机构一经确认报名成功，即可获得私募排排网“基金大师”试用六个月。对于大赛业绩突出的参赛机构，经大赛组委会综合评审，可以优先获得私募排排网直营店合作机会。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.award {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 20px;
    > div > .title {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        height: 61px;
        background: url('../assets/img/title-bg.png') no-repeat center / 100% 100%;
        font-size: 30px;
        font-weight: bold;
        color: #fff;
    }
}
.award-reward {
    padding-top: 60px;
    .award-reward-content {
        padding-top: 41px;
        > div .title {
            font-size: 20px;
            color: #fff;
            font-weight: bold;
            margin-top: 40px;
        }
        .tips {
            font-size: 16px;
            color: #fff;
            text-align: center;
        }
        table {
            width: 100%;
            margin-top: 21px;
            color: #fff;
            font-size: 16px;
            border-collapse: collapse;
            td {
                position: relative;
                border: 1px solid #3945a8;
                padding: 15px 27px;
                p {
                    line-height: 30px;
                }
            }
            .bg-color {
                background-color: #3945a8;
            }
            .bg-color2 {
                background-color: rgba(61, 73, 172, 0.4);
            }
        }
    }
}
.award-standard {
    padding-top: 88px;
    .award-standard-content {
        padding-top: 38px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        .item {
            width: 590px;
            margin-top: 35px;
            padding-bottom: 42px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            border-bottom: 1px solid #3945A8;
        }
        .item:nth-last-child(1) {
            border-bottom: none;
        }
        .item-left {
            width: 90px;
            margin-right: 20px;
            img {
                width: 100%;
            }
        }
        .item-right {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            padding-top: 24px;
            color: #fff;
            .title {
                font-size: 16px;
                font-weight: bold;
                line-height: 24px;
            }
            .content {
                margin-top: 28px;
                font-size: 14px;
                line-height: 24px;
                padding-right: 29px;
            }
        }
    }
}
</style>